import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const aiAssistantService = {
    getStandartTask,
    getContextualTask,
    getLocationSuggestions,
};

function getStandartTask(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/ai/standard-tasks`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.AiAssistantUsed, () => ({ mode: 'standard', task_type: data.type })));
}

function getContextualTask(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/ai/contextual-tasks`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.AiAssistantUsed, () => ({ mode: 'contextual', task_type: data.type })));
}

function getLocationSuggestions(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/ai/location-suggestions`, requestOptions)
        .then(handleResponse)
        .then(
            captureOnSuccess(ProductEvent.AiAssistantUsed, () => ({
                mode: 'location_suggestions',
                task_type: data.type,
            })),
        );
}
